import * as React from 'react';
import { useParams } from 'react-router';
import Form from '../../components/form/Form';
import TestForm from '../../components/form/TestForm';
import Panel from '../../components/containers/Panel';

export default function CreateDetails() {
    const { id, type } = useParams();

    return (
        <Panel>
            <Form isCreate={true} objtype={type} />
        </Panel>
    )
}